import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios, { CancelToken } from 'axios';
import { Alert } from 'react-bootstrap';

export default class Auth extends Component {
  constructor(props) {
    super(props);
    this.cancellers = [];
    this.state = {
      error: null,
      isLoading: true,
      username: '',
      password: '',
    };

    this.deauth();
  }

  componentWillUnmount() {
    this.cancellers.forEach(c => c.cancel());
  }

  onSubmit(e) {
    e.preventDefault();
    this.requestWillStart();

    axios.post(
      'auth',
      { username: this.state.username, password: this.state.password },
      { cancelToken: this.getNewCancelToken() },
    )
      .then(() => {
        console.log('logged in');
        this.props.history.push('/');
      })
      .catch(this.requestDidCatch.bind(this))
      .finally(() => {
        this.setState({ isLoading: false });
      });
  }

  getNewCancelToken() {
    const canceller = CancelToken.source();
    this.cancellers.push(canceller);

    return canceller.token;
  }

  deauth() {
    axios.post('deauth', { cancelToken: this.getNewCancelToken() })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  }

  requestWillStart() {
    this.cancellers.forEach(c => c.cancel());
    this.props.updateRefresh(true, false);
    this.setState({ isLoading: true, error: false });
  }

  requestDidCatch(error) {
    if (!axios.isCancel(error)) {
      console.error(error);
    }

    this.setState({ error });
    this.props.updateRefresh(false, axios.isCancel(error) ? false : error);
  }

  isSubmitEnabled() {
    return this.state.isLoading || !this.state.username || !this.state.password;
  }

  render() {
    if (this.state.isLoading && this.state.username === '' && this.state.password === '') {
      return (
        <div className="text-center">
          <FontAwesomeIcon icon="circle-notch" spin className="refresh-icon fa-2x" />
        </div>
      );
    }

    return (
      <div className="row">
        <form className="col-xs-12 col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4 form" onSubmit={e => this.onSubmit(e)}>
          <div className="panel panel-default">
            <div className="panel-body">
              {this.state.error ?
                <Alert bsStyle="warning" onDismiss={() => this.setState({ error: null })}>
                  <FontAwesomeIcon icon="exclamation-triangle" />
                  Could not log in, please try again
                </Alert>
                : null}

              <div className="form-group">
                <div className="input-group input-group-lg">
                  <span className="input-group-addon">
                    <FontAwesomeIcon icon="user-circle" />
                  </span>
                  <input
                    id="username-input"
                    className="form-control"
                    value={this.state.username}
                    onChange={e => this.setState({ username: e.target.value })}
                    type="text"
                    placeholder="Username"
                  />
                </div>
              </div>

              <div className="form-group">
                <div className="input-group input-group-lg">
                  <span className="input-group-addon">
                    <FontAwesomeIcon icon="key" />
                  </span>
                  <input
                    id="password-input"
                    className="form-control"
                    value={this.state.password}
                    onChange={e => this.setState({ password: e.target.value })}
                    type="password"
                    placeholder="Password"
                  />
                </div>
              </div>

              <button type="submit" className="btn btn-success btn-lg center-block" disabled={this.isSubmitEnabled()}>
                {this.state.isLoading
                  ? <FontAwesomeIcon icon="circle-notch" spin className="refresh-icon" />
                  : 'Login'}
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Auth/Auth.js